var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGradientBorderShadowOverlayBlur(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 390,
    height: 767,
    viewBox: "0 0 390 767",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2_5352)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_2_5352",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.0133 32.9247C44.5914 21.8942 54.0021 13.4208 65.0326 13.9989L360.627 29.4903C371.658 30.0684 380.131 39.4791 379.553 50.5097L345.98 691.11C345.402 702.141 335.992 710.614 324.961 710.036L29.3667 694.545C18.3361 693.967 9.86272 684.556 10.4408 673.526L44.0133 32.9247Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M44.0133 32.9247C44.5914 21.8942 54.0021 13.4208 65.0326 13.9989L360.627 29.4903C371.658 30.0684 380.131 39.4791 379.553 50.5097L345.98 691.11C345.402 702.141 335.992 710.614 324.961 710.036L29.3667 694.545C18.3361 693.967 9.86272 684.556 10.4408 673.526L44.0133 32.9247Z",
    fill: "url(#paint0_linear_2_5352)",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.0326 13.9989L64.9803 14.9975L360.575 30.489L360.627 29.4903L360.679 28.4917L65.085 13.0002L65.0326 13.9989ZM379.553 50.5097L378.554 50.4573L344.982 691.058L345.98 691.11L346.979 691.163L380.551 50.562L379.553 50.5097ZM324.961 710.036L325.013 709.038L29.419 693.546L29.3667 694.545L29.3143 695.544L324.909 711.035L324.961 710.036ZM10.4408 673.526L11.4394 673.578L45.012 32.9771L44.0133 32.9247L43.0147 32.8724L9.44218 673.473L10.4408 673.526ZM29.3667 694.545L29.419 693.546C18.94 692.997 10.8903 684.057 11.4394 673.578L10.4408 673.526L9.44218 673.473C8.83519 685.055 17.7323 694.937 29.3143 695.544L29.3667 694.545ZM345.98 691.11L344.982 691.058C344.433 701.537 335.492 709.587 325.013 709.038L324.961 710.036L324.909 711.035C336.491 711.642 346.372 702.745 346.979 691.163L345.98 691.11ZM360.627 29.4903L360.575 30.489C371.054 31.0382 379.103 39.9783 378.554 50.4573L379.553 50.5097L380.551 50.562C381.158 38.9799 372.261 29.0987 360.679 28.4917L360.627 29.4903ZM65.0326 13.9989L65.085 13.0002C53.5029 12.3932 43.6217 21.2903 43.0147 32.8724L44.0133 32.9247L45.012 32.9771C45.5612 22.498 54.5013 14.4483 64.9803 14.9975L65.0326 13.9989Z",
    fill: "white",
    fillOpacity: 0.2,
    mask: "url(#path-1-inside-1_2_5352)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2_5352",
    x: -54.606,
    y: -51.0479,
    width: 499.206,
    height: 826.131,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 12,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_2_5352"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 25
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2_5352"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2_5352",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2_5352",
    x1: -68.3444,
    y1: 215.489,
    x2: 457.553,
    y2: 509.949,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.05
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGradientBorderShadowOverlayBlur);
export default __webpack_public_path__ + "static/media/Gradient+Border+Shadow+OverlayBlur.11fc48176f20911aa57c1640bdda08c5.svg";
export { ForwardRef as ReactComponent };